import classes from "./index.module.scss";
import imgPh1Webp from "../images/ph1.webp";
import imgPh2Webp from "../images/ph2.webp";
import imgPh3Webp from "../images/ph3.webp";
import imgPh1Png from "../images/ph1.png";
import imgPh2Png from "../images/ph2.png";
import imgPh3Png from "../images/ph3.png";
import btnClasses from "../../../commons/Button.module.scss";
import heroTitleClasses from "../../../commons/HeroTitle.module.scss";
import Text from "../../../commons/Text";
import { ReactComponent as AppStore } from "../images/appstore.svg";
import RequestDemo from "../../../Button/RequestDemo";
import GooglePlayLink from "../GooglePlayLink";

export default function Hero() {
  return (
    <section className={classes.section}>
      <div className={classes.container}>
        <div className={classes.body}>
          <div className={classes.content}>
            <h1 className={heroTitleClasses.title}>
              WEEDAR
              <span></span>
            </h1>
            <div className={classes.wrapper}>
              <div className={classes.main}>
                <h3 className={heroTitleClasses.subtitle}>
                  cannabis products retailer
                </h3>
                <Text
                  text={[
                    `WeedAr is a fully-integrated ecosystem that connects cannabis brands to a revolutionary loyalty and distribution platform, powered by unique cutting edge technology.`,
                  ]}
                  className={classes.text}
                />
                <RequestDemo className={btnClasses.button} />
                <div className={classes.store_row}>
                  <div className={classes.appstore}>
                    <a
                      href="https://apps.apple.com/us/app/weelar/id1601307559"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <AppStore />
                    </a>
                    <span>Available for US App Store</span>
                  </div>
                  <GooglePlayLink />
                </div>
                <div className={classes.ph3}>
                  <picture>
                    <source srcSet={imgPh3Webp} type="image/webp" />
                    <source srcSet={imgPh3Png} type="image/png" />
                    <img src={imgPh3Png} alt="Yellow Dream Farm" width={1018} />
                  </picture>
                </div>
                <h3 className={classes.description}>
                  The results of our collaboration with WeedAr
                </h3>
              </div>
              <div className={classes.ph1}>
                <picture>
                  <source srcSet={imgPh1Webp} type="image/webp" />
                  <source srcSet={imgPh1Png} type="image/png" />
                  <img src={imgPh1Png} alt="Yellow Dream Farm" width={302} />
                </picture>
              </div>
            </div>
          </div>
          <div className={classes.ph2}>
            <picture>
              <source srcSet={imgPh2Webp} type="image/webp" />
              <source srcSet={imgPh2Png} type="image/png" />
              <img src={imgPh2Png} alt="Yellow Dream Farm" width={424} />
            </picture>
          </div>
        </div>
        <ul className={classes.list}>
          <li className={classes.item}>
            <h3>3X</h3>
            <p>3x initial capitalization increase</p>
          </li>
          <li className={classes.item}>
            <h3>full-cycle</h3>
            <p>coverage: from cultivating to distribution</p>
          </li>
          <li className={classes.item}>
            <h3>286%</h3>
            <p>number of active customers increase</p>
          </li>
        </ul>
      </div>
    </section>
  );
}
